import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const LyricsGlowBlurListItem = (props) => {
    const { glowSettingsBlur, updateLyricsStyle, maxGlowBlur } = props;
    
    const onGlowBlurChange = (value) => {
        previewHistoryBatch.start();
        
        updateLyricsStyle({ 
            glowSettings: { blur: value } 
        });
    };
    
    return (
        <SliderListItem
            title='Blur'
            value={glowSettingsBlur}
            displayMultiplier={100 / maxGlowBlur}
            min={0}
            max={100}
            step={1}
            onValueChange={onGlowBlurChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { glowSettings } = state.createPreview.present.videoSettings.lyrics.style;
    const glowSettingsBlur = glowSettings ? glowSettings.blur : 0;
    const { maxGlowBlur } = state.create.maxValues;

    return { 
        glowSettingsBlur,
        maxGlowBlur
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateLyricsStyle = (properties) => dispatch(createActions.updateLyricsStyle(properties));
    return { updateLyricsStyle }
}

export default connect(mapStateToProps, mapDispatchToProps)(LyricsGlowBlurListItem);
